// @owners { team: patients }
import { LgSpacing, ListBase } from '@alto/design-system';
import { type Transfer as HomescreenTransfer } from '@alto/scriptdash/alto/patient_app/homescreen/types/v1/transfer';
import React from 'react';
import { PendingTransferCard } from './PendingTransferCard';

type Props = {
  readonly transfers: HomescreenTransfer[];
  readonly refetchHomescreen: () => void;
};

export const PendingTransferSection = ({ transfers, refetchHomescreen }: Props) => {
  const transferItems = transfers.map((t) => ({
    key: t.id,
    component: (
      <PendingTransferCard
        transfer={t}
        refetchHomescreen={refetchHomescreen}
      />
    ),
  }));

  return (
    <ListBase
      items={transferItems}
      separator={<LgSpacing />}
    />
  );
};
